// extracted by mini-css-extract-plugin
export default {"checkbox":"SuSlM8r2qfrk2jTI7Ay9"};